/**
 * @readonly
 * @enum {string}
 */
export const ObjectColors = Object.freeze({
    GREEN: 'green',
    RED: 'red',
    GREY: 'grey',
    UK: 'uk',
    BLUE: 'blue',
    BLACK: 'black',
    WHITE: 'white',
    IVORY: 'ivory',
    EU: 'eu',
    ORANGE: 'orange',
    YELLOW: 'yellow'
})
